import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import GHref from 'tennders-market/common/components/element/GHref'
import GLoading from 'tennders-market/common/components/element/GLoading'
import { useDispatch, useSelector } from 'react-redux'
import { StateType } from 'tennders-common/types/StateType'
import { dispatchCarrierShareBox } from 'tennders-common/stores/modal/action'
import { resetSelectedRows } from 'tennders-common/stores/data/action'
import Select from 'react-select'
import useShareLoadWithCarriers from 'tennders-market/common/hooks/useShareLoadWithCarriers'
import GModal from './element/GModal'
import IconInfo from '../../../../icons/icon-gen-info.svg'

const CarrierShareBox = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const modalProps = useSelector((state:StateType) => state.modal.carrierShareBox)
  const {
    carriers,
    loading,
    setForm,
    onChange,
    filterBy,
    withForm,
    form,
    saving,
    share
  } = useShareLoadWithCarriers({
    modal: modalProps,
    onClose: () => dispatch(dispatchCarrierShareBox(false))
  })

  const cancelSelectedRows = () => dispatch(resetSelectedRows())

  const onClose = () => {
    cancelSelectedRows()
    setForm({ })
    filterBy('')
    dispatch(dispatchCarrierShareBox(false))
  }

  return (
    <GModal
      size={600}
      close={onClose}
      isOpen={!!modalProps}
      extraClass="tennders-carriers-share-modal"
    >
      <div className="w-100">
        <div className="d-flex row justify-space align-center mb-8 border-b">
          <div className="left d-flex row align-center">
            <div className="bold mr-8">{t('modal:select_carrier_share_load')}</div>
          </div>
        </div>
        <label className="form-label w-100 d-flex">
          {t('modal:choose_carrier')}
        </label>
        <div className="d-flex align-center w-100 mb-16">
          <Select
            isMulti
            className="w-100 mr-8"
            closeMenuOnSelect={false}
            placeholder={t('addLoad:search_for_carriers')}
            onChange={(selectedList) => {
              onChange('selectedCarriers', selectedList)
            }}
            defaultValue={[]}
            options={carriers?.map((c) => ({
              label: c.name,
              value: c.id,
              companyId: c.companyId
            }))}
            styles={{
              dropdownIndicator: (provided, state) => ({
                ...provided,
                transform: state.selectProps.menuIsOpen && 'rotate(180deg)'
              })
            }}
            onInputChange={filterBy}
          />
          {!withForm && (
            <GHref
              onClick={share}
              submitting={saving}
              className="btn standard-btn"
            >
              {t('common:share')}
            </GHref>
          )}
        </div>
        {t('common:previously_shared')}
        <div
          className="tennders-carriers-share-list tennders-custom-scroll mt-16 bg-color-white br-8"
          style={{ maxHeight: '320px' }}
        >
          {loading
            ? <GLoading size={24} />
            : !form?.sharedUsers && !modalProps?.isSharedWithAll && <p className="text-center">{t('modal:not_shared_with_carriers')}</p>}
          {!loading && form?.sharedUsers?.length > 0
            && (
              <table className="tennders-table-zebra text-12 lh-1-3">
                <tbody>
                  {form?.sharedUsers?.map((user) => (
                    <tr key={user?.id}>
                      <td colSpan={4} className="text-left w-75 p-0">{user?.name}</td>
                      <td className="text-right">
                        <GHref onClick={() => share(user)} className="btn-border standard-btn smaller text-12">{t('common:reshare')}</GHref>
                      </td>
                      <td className="text-right">
                        <GHref onClick={() => share(user, true)} className="btn-link smaller">{t('common:unshare')}</GHref>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
        </div>
        <div className="tennders-modal-or-separator">
          <span>{t('common:or')}</span>
        </div>
        <div className="text-center">
          <label className="form-label w-100 d-flex">
            {t('modal:share_with_all_carriers')}
          </label>
          <div className="text-12 d-flex align-center">
            <IconInfo />
            {t(`modal:${modalProps?.isSharedWithAll ? 'shared_all_info' : 'share_all_info'}`)}
          </div>
          <GHref
            onClick={() => share(false, modalProps?.isSharedWithAll, true)}
            className="btn-border standard-btn d-flex justify-center mt-16"
          >
            {modalProps?.isSharedWithAll ? t('common:unshare_with_all') : t('common:share_with_all')}
          </GHref>
        </div>
      </div>
    </GModal>
  )
}

export default CarrierShareBox
